import { BaseFeature, FeatureType } from '@core/shared/feature';
export class FaqBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/faq/feature","featureId":"common-faq"},
      bundledItemModels: ["FaqQuestionItem", "FaqCategoryItem"],
      // list is auto-generated by generate-model-ids
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'FaqFrontendFeature'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'FaqFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'FaqBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'FaqBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {
          faq: () => '/help'
        }
      }
    };
  }
}